module.exports = __webpack_public_path__ + "static/media/logo.2e149d61.png";